import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { Sparkles, X } from "lucide-react";
import OpportunityBody from "./OpportunityBody";
import { OPP_MODEL } from "../../lib/opportunityApi";

// Slide-out panel beside the Morning Brief: the drill-down and AI explanation of Today's Opportunity.
export default function OpportunityPanel({ req, onClose, onFresh, origin }) {
  useEffect(() => {
    if (!req) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [req, onClose]);
  if (!req) return null;
  return createPortal(
    <>
      <div data-testid="opp-backdrop" onClick={onClose} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[70] animate-fade-in" />
      <aside data-testid="opp-panel" role="dialog" aria-label="Explain Today's Opportunity"
             className="fixed top-0 right-0 h-screen w-full sm:w-[600px] lg:w-[680px] bg-bg border-l border-border shadow-2xl z-[71] flex flex-col fc-slide-in">
        <div className="px-5 pt-4 pb-3 border-b border-border flex items-start justify-between gap-4">
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-[0.22em] text-primary font-semibold mb-1 inline-flex items-center gap-1.5"><Sparkles size={11} /> AI Explain</div>
            <h2 className="font-display text-lg font-semibold tracking-tight leading-tight">Today's Opportunity</h2>
            <p className="text-[12px] text-muted mt-0.5">How the total is built, where it sits and what changed — explained by {OPP_MODEL} from the latest daily cycle.</p>
          </div>
          <button type="button" data-testid="opp-close" onClick={onClose} aria-label="Close"
                  className="w-8 h-8 shrink-0 inline-flex items-center justify-center border border-border hover:border-primary hover:text-primary rounded-sm transition-colors">
            <X size={14} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-5" data-testid="opp-scroll">
          <OpportunityBody key={req.nonce} req={req} onFresh={onFresh} origin={origin} />
        </div>
      </aside>
    </>,
    document.body,
  );
}
